<div class="info-box-container">
  <div class="title-container">
    @if (iconOptions && isDesktop) {
      <span nz-icon [nzType]="iconOptions.type" [nzTheme]="iconOptions.theme"></span>
    }
    <h2 [style.fontSize]="cssProperties?.['font_size_title'] + 'px'">{{ title }}</h2>
  </div>

  <p [style.fontSize]="cssProperties?.['font_size_subtitle'] + 'px'">{{ description }}</p>
</div>
